import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import HelloSign from 'hellosign-embedded';
import { TailSpin } from 'react-loader-spinner';
import { useTracking } from 'react-tracking';

import Header from '../../components/Header/Header';
import FormSiteList from '../../components/FormSiteList/FormSiteList';
import FormSiteModal from '../../components/FormSiteEmbed/FormSiteEmbed';
import DoxyContainer from '../../components/DoxyContainer/DoxyContainer';
import useModal from '../../utils/hooks/useModal';

import { getAssignedAssessments } from '../../api/services/Assessment';
// import { getAssignedDocuments } from '../../api/services/Documents';
import completeDocument, { createDocumentService } from '../../api/services/completeDocument';
// import { sendMessage } from '../../api/services/sendMessage';
import './AssessmentPortal.css';
import { sendMessage } from '../../api/services/sendMessage';
// import DocumentsList from '../../components/DocumentsList/DocumentsList';

const getAssessments = async (bundleKey, setAssignedAssessments, setPageType, setMessageId) => {
  try {
    const response = await getAssignedAssessments(bundleKey);
    setMessageId(response.data.data.messageId);
    setAssignedAssessments(response.data.data.forms);
    setPageType(response.data.data.bundleType);
  } catch (error) {
    console.log(error);
  }
  // .then((res) => {
  //   setMessageId(res.data.data.messageId);
  //   setAssignedAssessments(res.data.data.forms);
  //   console.log(res);
  //   setPageType(res.data.data.bundleType);
  // })
  // .catch((error) => {
  //   console.log(error);
  // });
};

// const getDocuments = (bundleKey, setAssignedDocuments) => {
//   getAssignedDocuments(bundleKey)
//     .then((res) => {
//       setAssignedDocuments(res.data.data.documents);
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// };

function AssessmentPortal() {
  const { bundleKey } = useParams();
  const { Track, trackEvent } = useTracking({ page: 'Assessment Portal' }, {
    dispatch: (data) => {
      if (data) {
        if (data.messageId) {
          console.log(data);
          sendMessage(data.messageId, data.event, data.eventDetails, data.result);
        }
      }
    },
  });
  const [isShowing, toggle] = useModal();
  const [embedParams, setEmbedParams] = useState({});
  const [assignedAssessments, setAssignedAssessments] = useState([]);
  const [messageId, setMessageId] = useState('');
  // const [assignedDocuments, setAssignedDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pageType, setPageType] = useState('assessment');
  const [instructions, setInstructions] = useState('');
  const [pageName, setPageName] = useState('');
  const [isComplete, setIsComplete] = useState(false);

  const [hsClient, setHsClient] = useState(null);

  useEffect(() => {
    getAssessments(bundleKey, setAssignedAssessments, setPageType, setMessageId);

    const client = new HelloSign({
      clientId: process.env.REACT_APP_HELLOSIGN_CLIENT_ID,
    });
    setHsClient(client);
  }, []);

  useEffect(() => {
    // getDocuments(bundleKey, setAssignedDocuments);
    let interval;

    if (!isShowing && !isComplete) {
      interval = setInterval(() => {
        getAssessments(bundleKey, setAssignedAssessments, setPageType, setMessageId);
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [bundleKey, isShowing, isComplete]);

  useEffect(() => {
    if (assignedAssessments.length > 0) {
      setIsLoading(false);
    }

    if (assignedAssessments.filter((assessment) => !assessment.complete).length === 0) {
      setIsComplete(true);
    } else {
      setIsComplete(false);
    }
  }, [assignedAssessments]);

  useEffect(() => {
    switch (pageType) {
      case 'survey':
        setPageName('Survey Portal');
        setInstructions('Please complete the following confidential survey about your recent '
            + 'Monarch experience');
        break;
      case 'registration':
        setPageName('Registration');
        setInstructions('Please complete the following forms. After completing, '
            + 'select "Finish Registration" to be redirected to an online waiting room to complete the '
            + 'registration process with a Monarch staff member.');
        break;
      default:
        setPageName('Assessment Portal');
        setInstructions('Please complete the following forms before your next visit.');
    }
    if (messageId) {
      trackEvent({ event: `Assessment Page Accessed - Bundle: ${bundleKey}`, eventDetails: { bundleKey }, messageId });
    }
  }, [pageType]);

  useEffect(() => {
    if (hsClient) {
      hsClient.on('sign', (data) => {
        if (messageId) {
          trackEvent({ event: 'Document signed', eventDetails: { signatureId: data.signatureId }, messageId });
        }
        completeDocument(data.signatureId);
        createDocumentService(data.signatureId)
          .then((res) => console.log(res))
          .catch((error) => console.log(error));
      });

      hsClient.on('close', () => {
        if (messageId) {
          trackEvent({ event: 'Document closed', messageId });
        }
      });
    }
  }, [hsClient]);

  return (
    <div>
      <Track>
        <Container>
          <TailSpin className="mx-auto" color="#00BFFF" height={200} width={200} visible={isLoading} />
        </Container>
        {!isLoading
          && (
          <Header pageName={pageName} />
          )}
        <Container fluid className="d-flex justify-content-center form-container">
          <Row>
            {!isLoading
          && (
          <div>
            <Row className="instructions">
              <h2>{instructions}</h2>
            </Row>
          </div>
          )}
            {assignedAssessments.length > 0
          && (
            <FormSiteList
              toggle={toggle}
              setEmbedParams={setEmbedParams}
              assessments={assignedAssessments}
              messageId={messageId}
              hsClient={hsClient}
            />
          )}
            {(pageType === 'registration' && !isLoading)
          && (
            <DoxyContainer isComplete={isComplete} />
          )}
          </Row>
        </Container>

        {
        isShowing
        && (
        <FormSiteModal
          isShowing={isShowing}
          toggle={toggle}
          updateAssigned={() => getAssessments(bundleKey, setAssignedAssessments, setPageType,
            setMessageId)}
          embedParams={embedParams}
          messageId={messageId}
        />
        )
      }
      </Track>
    </div>
  );
}

export default AssessmentPortal;
